import { render } from "./SideMenuItem.html?vue&type=template&id=b98e9aca&scoped=true&ts=true&external"
import script from "./SideMenuItem.vue?vue&type=script&lang=ts"
export * from "./SideMenuItem.vue?vue&type=script&lang=ts"

import "./SideMenuItem.scss?vue&type=style&index=0&id=b98e9aca&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b98e9aca"]])

export default __exports__